// MYC: cart-level quantity enforcement
// - Caps sample line items at 1
// - Enforces minimum quantity for non-sample line items
// Works on both cart drawer and full cart page (/cart)
(function() {
  const MAX_SAMPLE_QTY = 1;
  const SAMPLE_MESSAGE = 'Max 1 per customer';
  
  let lineItemRules = new Map();
  
  async function refreshCartRules() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      lineItemRules = new Map();
      cart.items.forEach((item, index) => {
        const rules = { isSample: false, minQty: 1, lineIndex: index + 1, key: item.key, variantId: item.variant_id };
        if (item.properties) {
          if (item.properties._is_sample) rules.isSample = true;
          if (item.properties._minimum_quantity) {
            const parsed = parseInt(item.properties._minimum_quantity, 10);
            if (!isNaN(parsed) && parsed > 0) rules.minQty = parsed;
          }
        }
        // Store under variant ID (most reliable)
        lineItemRules.set(String(item.variant_id), rules);
        // Store under item key
        lineItemRules.set(item.key, rules);
        // Store under line index (1-based)
        lineItemRules.set(String(index + 1), rules);
      });
      applyAllRules();
    } catch (e) {
      console.warn('MYC: cart rules refresh failed', e);
    }
  }
  
  function getRulesForInput(qtyInput) {
    // Strategy 1: data-quantity-variant-id on the input (cart page)
    const dataVariantId = qtyInput.getAttribute('data-quantity-variant-id');
    if (dataVariantId && lineItemRules.has(dataVariantId)) {
      return lineItemRules.get(dataVariantId);
    }
    
    // Strategy 2: data-variant-id on input
    const dataVarId = qtyInput.dataset.variantId;
    if (dataVarId && lineItemRules.has(dataVarId)) {
      return lineItemRules.get(dataVarId);
    }
    
    // Strategy 3: input id ends with line index (e.g. "Quantity-1", "Quantity-2")
    const id = qtyInput.id || '';
    const idMatch = id.match(/Quantity-(\d+)$/);
    if (idMatch && lineItemRules.has(idMatch[1])) {
      return lineItemRules.get(idMatch[1]);
    }
    
    // Strategy 4: parent line item element (e.g. <tr id="CartItem-1">)
    const cartItemRow = qtyInput.closest('[id^="CartItem-"]');
    if (cartItemRow) {
      const cartItemMatch = cartItemRow.id.match(/CartItem-(\d+)$/);
      if (cartItemMatch && lineItemRules.has(cartItemMatch[1])) {
        return lineItemRules.get(cartItemMatch[1]);
      }
    }
    
    // Strategy 5: parent with data-variant-id
    const itemEl = qtyInput.closest('[data-variant-id], [data-key], [data-line-item], [data-cart-item], tr.cart-item, .cart-item, .cart-drawer__line-item');
    if (itemEl) {
      const varId = itemEl.dataset.variantId;
      if (varId && lineItemRules.has(varId)) return lineItemRules.get(varId);
      
      const key = itemEl.dataset.key;
      if (key && lineItemRules.has(key)) return lineItemRules.get(key);
    }
    
    // Strategy 6: form-scoped (cart drawer uses this)
    const form = qtyInput.closest('form');
    if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.value && lineItemRules.has(idInput.value)) {
        return lineItemRules.get(idInput.value);
      }
    }
    
    return null;
  }
  
  function applyRulesToInput(qtyInput) {
    const rules = getRulesForInput(qtyInput);
    if (!rules) return;
    
    if (rules.isSample) {
      qtyInput.max = MAX_SAMPLE_QTY;
      qtyInput.setAttribute('data-max', MAX_SAMPLE_QTY);
      if (parseInt(qtyInput.value, 10) > MAX_SAMPLE_QTY) {
        qtyInput.value = MAX_SAMPLE_QTY;
      }
    } else if (rules.minQty > 1) {
      // Note: don't change min attribute itself (Shopify uses min=0 to allow item removal via qty=0)
      // We enforce via JS on click/change instead
      qtyInput.setAttribute('data-myc-min', rules.minQty);
      if (parseInt(qtyInput.value, 10) < rules.minQty && parseInt(qtyInput.value, 10) > 0) {
        // Don't auto-correct if user is going to 0 (item removal)
        qtyInput.value = rules.minQty;
      }
    }
  }
  
  function applyAllRules() {
    document.querySelectorAll('input[name="updates[]"], input[name^="updates"], input.quantity__input, input[name="quantity"]').forEach(applyRulesToInput);
  }
  
  function showMessage(targetEl, text) {
    if (!targetEl) return;
    const existing = targetEl.querySelector('.myc-cart-msg');
    if (existing) return;
    
    const msg = document.createElement('p');
    msg.className = 'myc-cart-msg';
    msg.textContent = text;
    msg.style.cssText = 'font-size: 1.1rem; color: rgba(0, 0, 0, 0.6); margin: 0.4rem 0 0 0; font-style: italic; font-weight: normal; line-height: 1.3;';
    targetEl.appendChild(msg);
    setTimeout(() => msg.remove(), 3000);
  }
  
  function findQtyInputFromButton(btn) {
    return btn.parentElement?.querySelector('input.quantity__input, input[name^="updates"], input[name="quantity"]') 
        || btn.closest('.quantity, .quantity-input, .cart-item__quantity, .cart-drawer__quantity, .quantity-popover-container')?.querySelector('input.quantity__input, input[name^="updates"], input[name="quantity"]')
        || btn.closest('form, [id^="CartItem-"]')?.querySelector('input.quantity__input, input[name^="updates"], input[name="quantity"]');
  }
  
  document.addEventListener('click', function(e) {
    const plusBtn = e.target.closest('button[name="plus"], .quantity__button[name="plus"], [data-quantity-button="plus"]');
    if (plusBtn) {
      const qtyInput = findQtyInputFromButton(plusBtn);
      if (qtyInput) {
        const rules = getRulesForInput(qtyInput);
        if (rules && rules.isSample && parseInt(qtyInput.value, 10) >= MAX_SAMPLE_QTY) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          showMessage(qtyInput.closest('.quantity, .cart-item__quantity, .cart-drawer__quantity, .cart-item__quantity-wrapper') || qtyInput.parentElement, SAMPLE_MESSAGE);
        }
      }
    }
    
    const minusBtn = e.target.closest('button[name="minus"], .quantity__button[name="minus"], [data-quantity-button="minus"]');
    if (minusBtn) {
      const qtyInput = findQtyInputFromButton(minusBtn);
      if (qtyInput) {
        const rules = getRulesForInput(qtyInput);
        const currentQty = parseInt(qtyInput.value, 10);
        // Block - button if going from minQty down (would go below minimum, but not to 0)
        if (rules && rules.minQty > 1 && currentQty <= rules.minQty && currentQty > 0) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          showMessage(qtyInput.closest('.quantity, .cart-item__quantity, .cart-drawer__quantity, .cart-item__quantity-wrapper') || qtyInput.parentElement, 'Min ' + rules.minQty + ' per order');
        }
      }
    }
  }, true);
  
  document.addEventListener('change', function(e) {
    if (!e.target.matches('input[name^="updates"], input.quantity__input, input[name="quantity"]')) return;
    applyRulesToInput(e.target);
  });
  
  refreshCartRules();
  
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      setTimeout(refreshCartRules, 200);
    });
  }
  
  const observer = new MutationObserver(function() {
    applyAllRules();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();